import { useEffect, useRef, useState } from 'react'

import UCMaxItems from '../design-detail/comps/uc-max-items'
import Dropdown from '../../components/dropdown/dropdownMenu'
import ArtInformationAndQRCode from '../design-detail/comps/artInformationAndQRCode'
import { IProdOrderLineItem } from '../../types/iprod-order'
import { getBackendApiUrl } from "../../config"
import { useSnapshot } from 'valtio'
import appModel from '../../models/app-model'
import { queryUCMItems } from '../../models/ucm-queries'
import { UcmLineItem } from './ucm-line-item'
import { UCMHeader } from './header'
import { UcmHeader } from './ucm-header'
import CircularProgressBar from '../../components/progressBar/progressBar'

// Styles
import styles from '../design-detail/art-details.module.css' // index.tsx
import artStyles from '../art-dashboard/art.module.css'
import { addAuthorizationHeader } from '../../api/network'

const flex = "flex-wrap gap-6 px-4 sm:px-6 lg:px-8"

function CloseIcon() {
  return (
    <button type="button" className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
      <span className="sr-only">Close</span>
      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  );
}

export function UCMProductionPage() {
  const appSnap = useSnapshot(appModel)
  const prodLineItems = appSnap.prodLineItems as IProdOrderLineItem[]
  const url = new URL(window.location.href)
  const docNo = url.searchParams.get('DocNo')
  const docLineNo = url.searchParams.get('DocLineNo')
  const [ucmHeader, setUmcHeader] = useState<UcmHeader>()
  const [ucmLineItems, setUcmLineItems] = useState<UcmLineItem[]>([])
  const [batchingAllUCMaxItems, setBatchingAllUCMaxItems] = useState<boolean>(false)
  const [batchingSelectedUCMaxItems, setBatchingSelectedUCMaxItems] = useState<boolean>(false)
  const [progress, setProgress] = useState<number>(0);
  const [_, setShowCheck] = useState<boolean>(false);
  const useEasyRip = prodLineItems.some(x => x.itemno_ === "_UC_MAX_ER");
  const [downloadDescription, setDownloadDescription] = useState<string>("");
  const printReasonList = [
    "Download Without Reporting",
    "First Print",
    "Adhesive Not Cured",
    "Banding",
    "Burnt Adhesive",
    "Color Mixing",
    "Corrupt File",
    "Excessive Adhesive",
    "Glycol Spots",
    "Missing File",
    "Registration",
    "Scratching",
    "Shortage",
    "Splotches",
    "Transfers Not Sticking To Film",
    "White Dropout",
    "Wrong Color",
    "Wrong Design",
    "Wrong Size"
  ];
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const getDeferredBoolean: () => {promise: Promise<{reasonSelected: false}| {reasonSelected: true, reason:string}>, resolveFn: (value: {reasonSelected: false}| {reasonSelected: true, reason:string}) => void} = () => {
    let resolveFn: (value: {reasonSelected: false}| {reasonSelected: true, reason:string}) => void;
    const promise = new Promise<{reasonSelected: false}| {reasonSelected: true, reason:string}>((resolve) => {
      resolveFn = resolve;
    });
    return { promise, resolveFn: resolveFn! };
  };
  const [reasonSelectedPromise, setReasonSelectedPromise] = useState<{promise: Promise<{reasonSelected: false}| {reasonSelected: true, reason:string}>, resolveFn: (value: {reasonSelected: false}| {reasonSelected: true, reason:string}) => void} | null>(null);

  useEffect(() => {
    //convert prodLineItems to UcmLineItems
    queryUCMItems(prodLineItems.filter(x => !!x.designdocidvel))
      .then((ucmLineItems) => {
        const totalQuantities = ucmLineItems.reduce((total, prodOrder) => total + prodOrder.quantity, 0);
        const processed = ucmLineItems.map((
          //x
        ) => {
          //asierad: ignore processed flag for the time being
          //const productionArtwork = x.productionArtwork
          return false//!!(productionArtwork && productionArtwork[0] && productionArtwork[0].DTFProcessed)
        })
        const totalRunTime = ucmLineItems.reduce((total, prodOrder) => total + prodOrder.size.width * prodOrder.size.height * prodOrder.quantity, 0) * 0.0094

        setUcmLineItems(ucmLineItems.map((x, i) => (
          {
            docId: x.docId,
            quantity: x.quantity,
            printQuantity: x.printQuantity,
            processed: processed[i],
            selected: false,
            size: x.size,
            productionArtwork: x.productionArtwork,
            productionArtworkPreview: x.productionArtworkPreview,
            originalArtwork: x.originalArtwork,

          })))

        setUmcHeader({
          docNo: docNo === null ? 'UNKNOWN' : docNo,
          lineNo: docLineNo == null ? 'UNKNOWN' : docLineNo,
          salesOrderNo: prodLineItems[0]?.salesorderno_vel,
          salesOrderLineNo: prodLineItems[0]?.saleslineno_vel.toString(),
          woEncodedMessage: `%P%${docNo} ${docLineNo}`,
          warehouseShipmentNo: prodLineItems[0]?.whseshipnovel,
          whEncodeMessage: `%WS%${prodLineItems[0]?.whseshipnovel}`,
          customerId: prodLineItems[0]?.customerNumber ?? "--",
          customerName: prodLineItems[0]?.customerName ?? "--",
          shippingAgent: prodLineItems.filter(x => !!x.shippingAgentServiceCode)[0]?.shippingAgentName ?? "--",
          shippingAgentService: prodLineItems.filter(x => !!x.shippingAgentServiceCode)[0]?.shippingAgentServiceDescription ?? "--",
          shipDate: prodLineItems[0]?.duedate,
          itemNo: prodLineItems[0]?.itemno_,
          totalQuantities: totalQuantities,
          runTime: totalRunTime,
          lineItemsCount: prodLineItems[0]?.lineItemsCount ?? 0,
          lineItemsShowing: ucmLineItems.length,
          useEasyRip: useEasyRip
        })
      })
      .catch((err) => {
        console.error('Error fetching documents for Multi item View:', err);
      })
  }, [docNo, docLineNo, prodLineItems])

  const handleSelectItem = (item: UcmLineItem) => {
    const newItems = ucmLineItems.map(x => {
      if (x.docId === item.docId) {
        x.selected = !x.selected
      }
      return x
    })
    setUcmLineItems(newItems)
  }

  const handlePrintQuantityChnage = (item: UcmLineItem, newQuantity: number) => {
    const newItems = ucmLineItems.map(x => {
      if (x.docId === item.docId) {
        x.printQuantity = Number.isInteger(newQuantity) ? newQuantity : 0
      }
      return x
    })
    setUcmLineItems(newItems)
  }

  const handlePrint = () => {
    window.print();
  };

  const processAll = async () => {
    const headers = addAuthorizationHeader({
      'Content-Type': 'application/json'
    });

    const processPayload = { docIds: ucmLineItems.map(x => x.docId), orderNumber: docNo }
    let intervalId: NodeJS.Timeout | null = null;

    try {
      intervalId = setInterval(() => {
        setProgress(prevProgress => {
          if (prevProgress < 35) {
            return prevProgress + 7;
          }
          clearInterval(intervalId!);
          return prevProgress;
        });
      }, 1000);

      const processResp = await fetch(`${getBackendApiUrl()}/ProcessUCMax`, {
        method: 'POST',
        headers,
        body: JSON.stringify(processPayload)
      });

      if (!processResp.ok) throw new Error("Error processing UCMax " + await processResp.text())

      const processRespObj = await processResp.json() as { processed: { id: string }[], errors: string[] }
      const processedDocs = new Set((processRespObj.processed).map(x => x.id as string))
      ucmLineItems.forEach(x => {
        if (processedDocs.has(x.docId)) {
          x.processed = true
        }
      })

      if (processRespObj.errors && (processRespObj.errors).some(x => typeof x != "undefined" && x != null)) {
        throw new Error("Some items weren't processed correctly: " + JSON.stringify(processRespObj))
      }

      setUcmLineItems([...ucmLineItems])
    } finally {
      if (intervalId) clearInterval(intervalId);
      setProgress(35);
    }
  }

  const batchAll = async (batchEasyRip: boolean, printReason: string) => {
    const headers = addAuthorizationHeader({
      'Content-Type': 'application/json'
    });

    const processPayload = {
      docs: ucmLineItems.map(x => ({ id: x.docId, quantity: x.printQuantity })),
      orderNo: prodLineItems[0]?.salesorderno_vel,
      outputType: batchEasyRip ? 'EasyRip' : 'Normal',
      createReportEntry: printReason !== "Download Without Reporting",
      reportEntryData: printReason == "Download Without Reporting" ? undefined : {
        operatorName: localStorage.getItem('operatorName') || "unknown",
        printLine: localStorage.getItem('printLine') || "unknown",
        reprint: printReason === "First Print" ? false : true,
        reprintReason: printReason
      }
    };

    const processResp = await fetch(`${getBackendApiUrl()}/BatchUCMax`, {
      method: 'POST',
      headers,
      body: JSON.stringify(processPayload)
    });

    if (!processResp.ok) throw new Error("Error batching UCMax " + await processResp.text())

    const reader = processResp.body?.getReader()
    const contentLength = +processResp.headers.get('Content-Length')!;
    let receivedLength = 0;
    const chunks = [];

    while (true) {
      const { done, value } = await reader!.read();
      if (done) break;
      chunks.push(value);
      receivedLength += value.length;
      setProgress(35 + (receivedLength / contentLength) * 65);
    }

    const blob = new Blob(chunks);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;

    if (processResp.headers.has("Content-Disposition")) {
      const disp = processResp.headers.get("Content-Disposition") as string;
      const dispParts = disp.split(';')
      if (dispParts.length > 1) {
        const fileToken = dispParts[1]
        const fileTokenParts = fileToken.split('=')
        const fileName = fileTokenParts.length > 1 ? fileTokenParts[1].replace(/"/g, '') : undefined;
        if (fileName) a.download = fileName
      }
    }

    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  const processSelected = async () => {
    const headers = addAuthorizationHeader({
      'Content-Type': 'application/json'
    });

    const processPayloadDocs = ucmLineItems.filter(x => x.selected).map(x => x.docId);
    const processPayload = { docIds: processPayloadDocs, orderNumber: docNo }
    let intervalId: NodeJS.Timeout | null = null;

    try {
      intervalId = setInterval(() => {
        setProgress(prevProgress => {
          if (prevProgress < 35) {
            return prevProgress + 7;
          }
          clearInterval(intervalId!);
          return prevProgress;
        });
      }, 1000);

      const processResp = await fetch(`${getBackendApiUrl()}/ProcessUCMax`, {
        method: 'POST',
        headers,
        body: JSON.stringify(processPayload)
      });

      if (!processResp.ok) throw new Error("Error processing UCMax " + await processResp.text())

      const processRespObj = await processResp.json() as { processed: { id: string }[], errors: string[] }
      const processedDocs = new Set((processRespObj.processed).map(x => x.id as string))
      ucmLineItems.forEach(x => {
        if (processedDocs.has(x.docId)) {
          x.processed = true
        }
      })

      if (processRespObj.errors && (processRespObj.errors).some(x => typeof x != "undefined" && x != null)) {
        throw new Error("Some items weren't processed correctly: " + JSON.stringify(processRespObj))
      }

      setUcmLineItems([...ucmLineItems])
    } finally {
      if (intervalId) clearInterval(intervalId);
      setProgress(35);
    }
  }

  const batchSelected = async (batchEasyRip: boolean, printReason: string) => {
    const headers = addAuthorizationHeader({
      'Content-Type': 'application/json'
    });

    const processPayload = {
      docs: ucmLineItems.filter(x => x.selected).map(x => ({
        id: x.docId,
        quantity: x.printQuantity
      })),
      orderNo: prodLineItems[0]?.salesorderno_vel,
      outputType: batchEasyRip ? 'EasyRip' : 'Normal',
      createReportEntry: printReason !== "Download Without Reporting",
      reportEntryData: printReason == "Download Without Reporting" ? undefined : {
        operatorName: localStorage.getItem('operatorName') || "unknown",
        printLine: localStorage.getItem('printLine') || "unknown",
        reprint: printReason === "First Print" ? false : true,
        reprintReason: printReason
      }
    };

    const processResp = await fetch(`${getBackendApiUrl()}/BatchUCMax`, {
      method: 'POST',
      headers,
      body: JSON.stringify(processPayload)
    });

    if (!processResp.ok) throw new Error("Error batching UCMax " + await processResp.text())

    const reader = processResp.body?.getReader();
    const contentLength = +processResp.headers.get('Content-Length')!;
    let receivedLength = 0;
    const chunks = [];

    while (true) {
      const { done, value } = await reader!.read();
      if (done) break;
      chunks.push(value);
      receivedLength += value.length;
      setProgress(35 + (receivedLength / contentLength) * 65);
    }

    const blob = new Blob(chunks);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;

    if (processResp.headers.has("Content-Disposition")) {
      const disp = processResp.headers.get("Content-Disposition") as string;
      const dispParts = disp.split(';');
      if (dispParts.length > 1) {
        const fileToken = dispParts[1];
        const fileTokenParts = fileToken.split('=');
        const fileName = fileTokenParts.length > 1 ? fileTokenParts[1].replace(/"/g, '') : undefined;
        if (fileName) a.download = fileName;
      }
    }

    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  const handleBatchAll = async (batchEasyRip: boolean) => {
    //Set the batching all UCMax items state to true to indicate that the batching process has started
    setBatchingAllUCMaxItems(true);
    const reasonSelected = reasonSelectedPromise ?? getDeferredBoolean();
    setReasonSelectedPromise(reasonSelected);
    //Show dialog with one button per reason in the printReasonList array to make the customer select the reason for printing
    setIsModalOpen(true);      
    const reasonSelectedResult = await reasonSelected.promise;
    setReasonSelectedPromise(null);
    if(reasonSelectedResult && reasonSelectedResult.reasonSelected) {
      //Set the download description based on the batchEasyRip parameter
      setDownloadDescription(batchEasyRip ? "EasyRip (All Files)" : "Standard (All Files)");
      //Reset the progress to 0 before starting the batching process
      setProgress(0);
      try {
        //If any of the UCMax line items are not processed, call the processAll function to process them
        if (ucmLineItems.some(x => !x.processed)) await processAll();
        //Call the batchAll function to batch all UCMax items based on the batchEasyRip parameter
        await batchAll(batchEasyRip, reasonSelectedResult.reason);

        //Is this still being used at all?
        setShowCheck(true);
        setTimeout(() => {
          //Is this still being used at all?
          setShowCheck(false);
          //Reset the download description and batching state after a delay of 2 seconds
          setDownloadDescription("");
          //Reset the batching all UCMax items state to false to indicate that the batching process has completed
          setBatchingAllUCMaxItems(false);
        }, 2000);
      } catch (err) {
        alert("Failed to batch all UCMax items");
        console.error(err);
        setDownloadDescription("");
        setBatchingAllUCMaxItems(false);
      }
    }
    else {
      setBatchingAllUCMaxItems(false);
    }
  };

  const handleBatchSelected = async (batchEasyRip: boolean) => {
    setBatchingSelectedUCMaxItems(true);
    const reasonSelected = reasonSelectedPromise ?? getDeferredBoolean();
    setReasonSelectedPromise(reasonSelected);
    //Show dialog with one button per reason in the printReasonList array to make the customer select the reason for printing
    setIsModalOpen(true);      
    const reasonSelectedResult = await reasonSelected.promise;
    setReasonSelectedPromise(null);
    if(reasonSelectedResult && reasonSelectedResult.reasonSelected) {
      setDownloadDescription(batchEasyRip ? "EasyRip (Selected Files)" : "Standard (Selected Files)");
      setProgress(0);
      try {
        const processedSelected = ucmLineItems.filter(x => x.selected).map(x => x.processed);
        if (processedSelected.some(x => !x)) await processSelected();
        await batchSelected(batchEasyRip, reasonSelectedResult.reason);

        setShowCheck(true);
        setTimeout(() => {
          setShowCheck(false);
          setDownloadDescription("");
          setBatchingSelectedUCMaxItems(false);
        }, 2000);
      } catch (err) {
        alert("Failed to batch selected UCMax items");
        console.error(err);
        setDownloadDescription("");
        setBatchingSelectedUCMaxItems(false);
      }
    }
    else {
      setBatchingSelectedUCMaxItems(false);
    }
  };

  const MainBar = () => {
    const [operatorName, setOperatorName] = useState<string>(localStorage.getItem('operatorName') || "");
    const [printLine, setPrintLine] = useState<string>(localStorage.getItem('printLine') || "");
    const hasUCMaxItems = ucmLineItems?.length > 0 && ucmLineItems?.some(x => x.printQuantity > 0);
    const hasUCMaxSelectedItems = ucmLineItems.some(x => x.selected && x.printQuantity > 0);
    const isOperatorNameEmpty = (operatorName?.trim() ?? "") === "";
    const isPrintLineEmpty = (printLine?.trim() ?? "") === "";
    const isOperatorNameOrPrintLineEmpty = isOperatorNameEmpty || isPrintLineEmpty;
    const processing = batchingAllUCMaxItems || batchingSelectedUCMaxItems;
    const disableAllFilesButtons = !hasUCMaxItems || processing || isOperatorNameOrPrintLineEmpty;
    const disableSelectedFilesButtons = !hasUCMaxSelectedItems || processing || isOperatorNameOrPrintLineEmpty;
    const operatorNameInteracted = useRef<boolean>(false);
    const operatorNameRef = useRef<HTMLInputElement | null>(null);
    const operatorNameCursorRef = useRef<number | null>(null);
    //read from local storage if operator name and print line exist
    useEffect(() => {
      if (operatorNameRef.current && operatorNameInteracted.current) {
        operatorNameRef.current.focus();

        if (operatorNameCursorRef.current !== null) {
          operatorNameRef.current.setSelectionRange(operatorNameCursorRef.current, operatorNameCursorRef.current);
        }
      }
    }, [operatorName]);
    
    const printLineInteracted = useRef<boolean>(false);
    const printLineRef = useRef<HTMLInputElement | null>(null);
    const printLineCursorRef = useRef<number | null>(null);
    useEffect(() => {
      if (printLineRef.current && printLineInteracted.current) {
        printLineRef.current.focus();

        if (printLineCursorRef.current !== null) {
          printLineRef.current.setSelectionRange(printLineCursorRef.current, printLineCursorRef.current);
        }
      }
    }, [printLine]);


    const ucMaxButtons = <>
      {/* Batch options */}
      <Dropdown
        buttonText="Download"
        setOverflow={true}
        menuItems={[
          {
            text: batchingAllUCMaxItems ? "Download Selected (Standard)" : "Download Selected Files (Standard)",
            onItemClicked: () => disableSelectedFilesButtons ? void 0 : handleBatchSelected(false),
            disabled: disableSelectedFilesButtons
          },
          {
            text: batchingAllUCMaxItems ? "Download Selected (EasyRip)" : "Download Selected Files (EasyRip)",
            onItemClicked: () => disableSelectedFilesButtons ? void 0 : handleBatchSelected(true),
            disabled: disableSelectedFilesButtons
          },
          {
            text: batchingAllUCMaxItems ? "Download All (Standard)" : "Download All Files (Standard)",
            onItemClicked: () => disableAllFilesButtons ? void 0 : handleBatchAll(false),
            disabled: disableAllFilesButtons,
            style: { background: '#F9FAFB' }
          },
          {
            text: batchingAllUCMaxItems ? "Download All (EasyRip)" : "Download All Files (EasyRip)",
            onItemClicked: () => disableAllFilesButtons ? void 0 : handleBatchAll(true),
            disabled: disableAllFilesButtons,
            style: { background: '#F9FAFB' }
          },
        ]}
      />
    </>

    return (
      <div className={[flex, styles.mainBar].join(' ')}>
        <h3 className="text-base font-light leading-6 text-white uppercase">
          <ArtInformationAndQRCode
            LineNo={docLineNo}
            DocNo={docNo}
            isProductionMode={true}
          />
        </h3>
        {!(batchingAllUCMaxItems || batchingSelectedUCMaxItems) &&
          <input
            type="text"
            placeholder={"Enter operator name..."}
            className={styles.operatorInput}
            value={operatorName}
            ref={(el) => {
              operatorNameRef.current = el;
            }}
            onChange={(e) => {
              operatorNameInteracted.current = true;
              operatorNameCursorRef.current = e.target.selectionStart;
              setOperatorName(e.target.value);
              localStorage.setItem('operatorName', e.target.value);
            }}
          />
        }
        {!(batchingAllUCMaxItems || batchingSelectedUCMaxItems) &&
        <input
          type="text"
          className={styles.operatorInput}
          value={printLine}
          ref={(el) => {
            printLineRef.current = el;
          }}
          placeholder="Enter print line..."
          onChange={(e) => {
            printLineInteracted.current = true;
            printLineCursorRef.current = e.target.selectionStart;
            setPrintLine(e.target.value);
            //store in local storage
            localStorage.setItem('printLine', e.target.value);
          }}
        />
        }
        <div className={styles.navBarButtonsWrapper}>
          {downloadDescription && <div className={styles.downloadDescription}>{"Downloading " + downloadDescription}</div>}
          {(batchingAllUCMaxItems || batchingSelectedUCMaxItems) &&
            <div className={styles.progressWrapper}>
              <CircularProgressBar progress={progress} />
            </div>
          }
          {ucMaxButtons}
          <button
            className={`${artStyles.orangeBtn} ${styles.printBtn} non-printable`}
            onClick={handlePrint}>
            <svg
              width={"22px"}
              height={"22px"}
              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round"
                d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z" />
            </svg>
          </button>
        </div>
      </div>
    );
  };

  return <div className={styles.multiWrapper}>
    <div className={styles.nonPrintable}>
      <MainBar />
    </div>
    {ucmHeader === undefined ? <></> : <UCMHeader header={ucmHeader} />}
    <UCMaxItems
      lineItems={ucmLineItems}
      docNo={docNo ?? ''}
      lineNo={docLineNo ?? ''}
      onSelectItem={handleSelectItem}
      onPrintQuantityChnage={handlePrintQuantityChnage}
    />
    {isModalOpen && <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <span>Select Print Reason</span>
          <div className={styles.modalCloseIcon} onClick={() => { 
              setIsModalOpen(false);
              if(reasonSelectedPromise) {
                reasonSelectedPromise.resolveFn({reasonSelected: false});
                setReasonSelectedPromise(null);
              }
            }}>
            <CloseIcon />
          </div>
        </div>
        {/* We want the modal body to display three columns of buttons */}
        <div className={styles.modalBody}>
        {printReasonList.map((reason) => (
          <button className={styles.modalButton} key={reason} onClick={() => {
            setIsModalOpen(false);
            if(reasonSelectedPromise) {
              reasonSelectedPromise.resolveFn({reasonSelected: true, reason: reason});
              setReasonSelectedPromise(null);
            }
          }}>
            {reason}
          </button>
        ))}
        </div>
      </div>
    </div>
    }
  </div>
}